import React, { useEffect, useState, useCallback, useRef } from 'react'
import {connect} from 'react-redux';
import { TicketVistaCard } from '@app/components/index';
import TablaTicketService from '@app/services/tablaTicket.service';

const ITEMS_PER_PAGE = 15;

function TabsTicketIndividually({
    filtro,
    ticketrefresh,
    onCountChange
}) {
    const [tickets, setTickets] = useState([]);
    const [filtroTK, setFiltroTK] = useState([]);
    const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);
    const observerRef = useRef(null);

    const lastItemRef = useCallback((node) => {
        if (observerRef.current) observerRef.current.disconnect();
        observerRef.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && visibleCount < filtroTK.length) {
                setVisibleCount((prev) => Math.min(prev + ITEMS_PER_PAGE, filtroTK.length));
            }
        });
        if (node) observerRef.current.observe(node);
    }, [visibleCount, filtroTK.length]);

    const actualizar = () =>{
        TablaTicketService.getAll({
            consulta: 'individual',
            cvv: true
        })
        .then((response)=>{
            setTickets(Array.isArray(response) ? response : []);
        })
        .catch(() => {
            setTickets([]);
        })
    }

    useEffect(() => {
        let resultado = tickets;
        if(filtro !== 'TODOS'){
            resultado = resultado.filter((tk) => tk?.ticket?.estado_tk === filtro);
        }
        setFiltroTK(resultado);
        if(onCountChange) onCountChange(resultado.length);
        setVisibleCount(ITEMS_PER_PAGE);
    }, [filtro, tickets, onCountChange])

    useEffect(() => {
        if(ticketrefresh?.reloadingInd){
          actualizar();
        }
    }, [ticketrefresh])

    useEffect(() => {
        actualizar();
    }, [])

    const visibleItems = filtroTK.slice(0, visibleCount);

    return (
        <div className="p-3 p-lg-5">
            {filtroTK.length > 0 && (
                <div className="mb-3">
                    <span
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            backgroundColor: '#dc3545',
                            color: '#fff',
                            borderRadius: '20px',
                            padding: '4px 12px',
                            fontSize: '13px',
                            fontWeight: '600',
                        }}
                    >
                        <i className="fas fa-ticket-alt mr-1" />
                        {filtroTK.length}
                        {' ticket'}
                        {filtroTK.length !== 1 ? 's' : ''}
                    </span>
                </div>
            )}
            <div className="row">
                <div className="offset-lg-12 col-lg-12">
                    {tickets && filtroTK?.length > 0 ? (
                        <>
                            {visibleItems.map((ticket, index) => {
                                const isLast = index === visibleItems.length - 1;
                                return (
                                    <div
                                        ref={isLast ? lastItemRef : null}
                                        key={ticket.ticket.id_tk}
                                        className="mb-3"
                                    >
                                        <TicketVistaCard
                                            item={ticket.ticket}
                                            tratos={ticket.tratos}
                                            hideClickMap
                                        />
                                    </div>
                                )
                            })}
                            {visibleCount < filtroTK.length && (
                                <div className="text-center py-3">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">
                                            Cargando...
                                        </span>
                                    </div>
                                </div>
                            )}
                        </>
                    ):(
                        <div className='alert alert-light mt-2 text-center'>
                            <i className="fas fa-user" style={{fontSize: 200, color: 'gray'}} />
                            <div style={{fontSize: 20, color: 'gray'}}>
                                Aún no se te asignaron tickets
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    ticketrefresh: state.ticketrefresh
})

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(TabsTicketIndividually)